import { hasAllPermissions, hasPermission } from '@goparrot/users-v2-sdk';
import type { IReadRoleV2Dto, PermissionsV2ValueType } from '@goparrot/users-v2-sdk';

export const checkForPermissions = (permission: PermissionsV2ValueType | PermissionsV2ValueType[], roleV2: IReadRoleV2Dto) => {
  return Array.isArray(permission) ? hasAllPermissions(roleV2, permission) : hasPermission(roleV2, permission);
};
